import {PatchCommunication} from 'domain/usecases/private/communications/patch-communication';
import {PatchCommunicationService} from './types';

function patchCommunication(
	patchCommunicationFactory: PatchCommunication,
): PatchCommunicationService {
	return {
		perform: async params => patchCommunicationFactory.patch(params),
	};
}

export {patchCommunication};
